var ClearContent = function() {
    this.setText();
    return this;
}

export default ClearContent;

